import { useTranslate } from "@similarweb/i18n-provider";

import type { SwitchFilterModel } from "../../../models/SwitchFilterModel";
import type { IFilterViewBaseProps } from "../../../types/filterInstance";
import OnOffSwitchGroup from "../../atoms/OnOffSwitchGroup";

export const OnOffSwitchFilter = ({
    filter,
    value,
    isDisabled,
    onFilterUpdate,
}: IFilterViewBaseProps<SwitchFilterModel>) => {
    const { translate } = useTranslate();

    const isSelected = isDisabled || !!value;

    return (
        <OnOffSwitchGroup
            label={translate(filter.label)}
            isSelected={isSelected}
            isDisabled={isDisabled}
            onClick={() => onFilterUpdate(!isSelected)}
        />
    );
};
